import { css } from '@emotion/css';

import { FieldOverrides } from '@/components/Form';

export const fieldStyleOverrides = css`
  .field-header-container > :not([hidden]) ~ :not([hidden]) {
    margin-top: 0.8rem;
  }

  .field-container > :not([hidden]) ~ :not([hidden]) {
    margin-top: 1.6rem;
  }

  .MuiCheckbox-root {
    margin-inline-start: 0.8rem;
    margin-inline-end: 0.4rem;
    margin-top: 0.2rem;
  }
`;

const formOverrides: FieldOverrides = {
  Error: { className: 'mx-8 mt-4' },
  FieldContainer: { className: fieldStyleOverrides },
  Label: { variant: 'heading-xs' },
  spacing: {
    row: 'space-y-40',
  },
};

export default formOverrides;
